/** Daily Logs Form — content helpers (Documents tab clinical form). */

export const DAILY_LOG_FORM_TYPE = "daily_log_form";
export const DAILY_LOG_FORM_SECTION = "daily-logs";
export const DAILY_LOG_FORM_NAME = "Daily Logs Form";

/**
 * Visit entry codes — same groups as Route Sheet.
 * Users may pick from the list or type a custom value.
 */
export const DAILY_LOG_VISIT_CODE_GROUPS = [
  { group: "Billable", codes: ["E", "RV", "IV", "RC", "RE", "DC"] },
  { group: "Non-Billable", codes: ["Ref", "NF", "S"] },
  { group: "Office", codes: ["O", "IS"] },
];

export const DAILY_LOG_VISIT_CODES = DAILY_LOG_VISIT_CODE_GROUPS.flatMap(
  (g) => g.codes,
);

/** @deprecated use DAILY_LOG_VISIT_CODE_GROUPS */
export const DAILY_LOG_CODE_OPTIONS = DAILY_LOG_VISIT_CODES.map((code) => ({
  value: code,
  label: code,
}));

export const todayYmd = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const emptyVisitEntry = () => ({
  id: `entry-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  date: todayYmd(),
  code: "",
  timeIn: "",
  timeOut: "",
  mileage: "",
  patientSignatureImage: null,
});

export const emptyDailyLogPayload = () => ({
  logDate: todayYmd(),
  timeIn: "",
  timeOut: "",
  dailyLogsNotes: "",
  visitEntries: [emptyVisitEntry()],
  clinicianSignatureName: "",
  clinicianSignatureText: "",
  clinicianSignedAt: null,
  reviewComments: "",
});

export const normalizeVisitEntries = (raw) => {
  const list = Array.isArray(raw) ? raw : [];
  if (!list.length) return [emptyVisitEntry()];
  return list.map((row, idx) => ({
    id: row?.id || `entry-${idx + 1}`,
    date: row?.date || todayYmd(),
    code: row?.code != null ? String(row.code) : "",
    timeIn: row?.timeIn || "",
    timeOut: row?.timeOut || "",
    mileage:
      row?.mileage == null || row?.mileage === ""
        ? ""
        : String(row.mileage),
    patientSignatureImage: row?.patientSignatureImage || null,
  }));
};
